import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import apiVRR from '../../libs/axios/apis';
import endPoints from '../../services/endpoints';
import { TCardInsight } from '../../containers/Insights/CardsContainer/types';
import { TFilters } from '../../containers/Insights/FilterContainer/types';

export const fetchInsights = createAsyncThunk(
  'insights/fetchInsights',
  async (_, { getState }) => {
    return apiVRR().get(endPoints.INSIGHTS.LIST, {
      params: {
        id: (getState() as any).setting.vrr_preferences.current_account_id,
        start: (getState() as any).setting.vrr_preferences.period.from,
        end: (getState() as any).setting.vrr_preferences.period.to,
        label: (getState() as any).app.funnel
      }
    });
  }
);

export const fetchFilters = createAsyncThunk(
  'insights/fetchFilters',
  async (_, { getState }) => {
    return apiVRR().get(endPoints.INSIGHTS.FILTERS, {
      params: {
        id: (getState() as any).setting.vrr_preferences.current_account_id,
        start: (getState() as any).setting.vrr_preferences.period.from,
        end: (getState() as any).setting.vrr_preferences.period.to,
        label: (getState() as any).app.funnel
      }
    });
  }
);

export const getInsights = (state: RootState): TCardInsight[] | null =>
  state.insights.list;

export const getFilters = (state: RootState): TFilters =>
  state.insights.filters;
